import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  makeStyles,
  Tooltip,
} from '@material-ui/core';
import React from 'react';
import FolderIcon from '@material-ui/icons/Folder';
import { HighlightOffRounded } from '@material-ui/icons';
import PublishIcon from '@material-ui/icons/Publish';

interface CreateFolderOrAddFileDialogProps {
  open: boolean;
  handleClose: () => void;
  handleUploadClick: () => void;
  handleCreateClick: () => void;
  /** Whether the upload option takes whole folders as well as loose files. */
  allowFolders?: boolean;
  disableUpload?: boolean;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  /**
   * Wide enough for the two options side by side where there is room, and no wider than the screen
   * where there is not -- a fixed 500 is more than a phone has once the dialog's own margins are
   * taken off.
   */
  paperRoot: {
    minWidth: 500,
    [theme.breakpoints.down('xs')]: {
      minWidth: 0,
      width: '100%',
      margin: 16,
    },
  },
  /** The two options sit side by side until they cannot, then stack. */
  options: {
    display: 'flex',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
    gap: 16,
  },
  button: {
    height: 128,
    width: 180,
    maxWidth: '100%',
    background: '#0947B9',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
    borderRadius: 4,
    transition: '0.2s',
    cursor: 'pointer',
    '&:hover': {
      background: '#4380ED',
    },
  },
  buttonDisabled: {
    height: 128,
    width: 180,
    maxWidth: '100%',
    background: '#C9C8C9',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
    borderRadius: 4,
    transition: '0.2s',
  },
  rootIconButton: {
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  tooltipText: {
    textAlign: 'center',
    textJustify: 'auto',
  },
}));
export default function CreateFolderOrAddFileDialog(props: CreateFolderOrAddFileDialogProps) {
  const {
    open,
    handleClose,
    handleUploadClick,
    handleCreateClick,
    allowFolders,
    disableUpload,
  } = props;
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      className={classes.root}
      onClose={handleClose}
      maxWidth="md"
      PaperProps={{ classes: { root: classes.paperRoot } }}
    >
      <DialogTitle>
        <IconButton
          style={{ right: '24px', top: '24px', position: 'absolute' }}
          onClick={handleClose}
          classes={{
            root: classes.rootIconButton,
          }}
        >
          <HighlightOffRounded />
        </IconButton>
      </DialogTitle>

      <DialogContent style={{ paddingTop: 48, paddingBottom: 48 }}>
        <div className={classes.options}>
          <Box
            className={classes.button}
            onClick={() => {
              handleClose();
              handleCreateClick();
            }}
          >
            <FolderIcon style={{ width: 48, height: 48, color: 'white' }} />{' '}
            <div style={{ color: 'white' }}>Create Folder</div>
          </Box>
          <Tooltip
            arrow
            placement="bottom"
            title={disableUpload ? 'You may only upload files inside of a folder' : ''}
            open
            classes={{ tooltip: classes.tooltipText }}
          >
            <Box
              className={disableUpload ? classes.buttonDisabled : classes.button}
              onClick={
                disableUpload
                  ? undefined
                  : () => {
                      handleClose();
                      handleUploadClick();
                    }
              }
            >
              <PublishIcon style={{ width: 48, height: 48, color: 'white' }} />{' '}
              <div style={{ color: 'white', textAlign: 'center' }}>
                {allowFolders ? 'Upload Files or Folders' : 'Upload Files'}
              </div>
            </Box>
          </Tooltip>
        </div>
      </DialogContent>
    </Dialog>
  );
}
